module.exports = __webpack_public_path__ + "img/ceo.79a07928.svg";